import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input, Switch } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { baseApiUrl } from "../../services/api";

import axios from "axios";
import { jwtDecode } from "jwt-decode"; // Importation corrigée
import { ca } from "date-fns/locale";



const Publication = () => {
  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");

  const [document, setDocument] = useState(null);
  const [image, setImage] = useState("");

  const [zoneExecution, setZoneExecution] = useState(null);

  const [impactEconomique, setImpactEconomique] = useState(null);

  const [impactSocial, setImpactSocial] = useState(null);

  const [impactEnvironnemental, setImpactEnvironnemental] = useState(null);


  const [video, setVideo] = useState("");


  const [calendrierFin, setCalendrierFin] = useState("");
  const [calendrierDebut, setCalendrierDebut] = useState("");

  const [step, setStep] = useState(1);

  const [categorieId, setCategorieId] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [projetId, setProjetId] = useState(null);
  const [sviewingProjet, setSviewingProjet] = useState("");
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteProjet, setDeleteProjet] = useState(null);

  const [projetToDelete, setProjetToDelete] = useState(null);
  const showDeleteModal = (id) => {
    setProjetToDelete(id);
    setIsDeleteModalVisible(true);
  };

  const handleCancelDelete = () => {
    setIsDeleteModalVisible(false);
    setProjetToDelete(null);
  };
  const confirmDelete = async () => {
    if (projetToDelete) {
      await handleDelete(projetToDelete);
      setIsDeleteModalVisible(false);
    }


  };

  const handleDeleteConfirm = (projet) => {
    setDeleteProjet(projet);
    setDeleteModalVisible(true);
  };
  const [projets, setProjets] = useState([]);
  const [publications, setPublications] = useState([]);

  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProjet, setEditingProjet] = useState(null);
  const [viewingProjet, setViewingProjet] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategorie, setSelectedCategorie] = useState(null);

  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Récupérer le premier fichier sélectionné
    if (file) {
      setImage(file); // Mettre à jour l'état avec l'image sélectionnée
    }
  };

  // const truncateText = (text, wordLimit) => {
  //   const words = text.split(" ");
  //   if (words.length > wordLimit) {
  //     return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
  //   }
  //   return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
  // };



  const fetchPublications = async () => {
    try {
      const response = await baseApiUrl.get("/publication/liste");
      console.log("Données reçues des publication:", response.data);

      // Vérifie que les données sont bien un tableau avant de les stocker
      setPublications(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erreur lors de la récupération des questions:", error);
    }
  };


  const fetchCategories = async () => {
    try {
      const response = await baseApiUrl.get(
        "/categorie/liste"
      );

      // Transformer les données pour correspondre au format des options de <Select>
      const options = response.data.map((category) => ({
        value: category.id, // Utiliser l'identifiant ou un autre attribut unique de la catégorie
        label: category.nom, // Utiliser le nom ou un autre attribut descriptif de la catégorie
      }));

      setCategoriesOptions(options);
    } catch (error) {
      console.error("Erreur lors de la récupération des catégories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchPublications();
  }, []);



  const handleAddProjet = async (e) => {
    e.preventDefault();

    if (!titre) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formData = new FormData();

      const projetData = {
        titre,
        description,

        categorieId: selectedCategorie,
        zoneExecution,
        impactEconomique,
        impactEnvironnemental,
        impactSocial,


      };

      formData.append("publication", new Blob([JSON.stringify(projetData)], {
        type: "application/json"
      }));

      if (document) {
        formData.append("document", document);
      }
      if (image) {
        formData.append("image", image);
      }
      if (video) {
        formData.append("video", video);
      }

      console.log("Données du publication:", projetData);

      console.log("Données du date:", formData);


      // ✅ Correction de l'appel API avec Axios
      const response = await baseApiUrl.post("/publication/create", formData);

      // ✅ Récupération correcte des données
      const newProjet = response.data;

      console.log("Réponse API:", newProjet);

      setProjets([newProjet, ...projets]);

      console.log("Réponse API:", newProjet);

      // ✅ Notification de succès
      openNotificationWithIcon("success", "Publication ajouté avec succès.");
      fetchPublications();
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout du projet.");
      console.error("Erreur détectée:", error.response?.data || error.message || error);
    }

    resetForm();
  };

  useEffect(() => {
    const token = localStorage.getItem("token"); // Assurez-vous que c'est le bon nom de clé
    if (token) {
      try {
        const decoded = jwtDecode(token); // Utilisation de jwtDecode
        setCurrentUser(decoded); // Décodez et stockez les informations de l'utilisateur
        console.log("Utilisateur connecté:", decoded); // Vérifiez les informations de l'utilisateur
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    } else {
      console.warn("Aucun token trouvé dans localStorage."); // Avertir si aucun token n'est trouvé
    }

  }, []);


  const handleEditProjet = async (e) => {
    e.preventDefault();

    // Vérification si un projet est sélectionné pour la modification
    if (!editingProjet) {
      openNotificationWithIcon("error", "Aucun projet sélectionné pour la modification.");
      return;
    }

    // Vérification que tous les champs nécessaires sont remplis
    if (!titre) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    // Préparation des données du projet
    const projetData = {
      titre,
      description,
      categorieId: selectedCategorie,
      zoneExecution,
      impactEconomique,
      impactEnvironnemental,
      impactSocial,

    };

    // Création de FormData pour les requêtes multipart/form-data
    const formData = new FormData();
    formData.append("publication", new Blob([JSON.stringify(projetData)], { type: "application/json" }));


    if (image) formData.append("image", image); // Ajout de l'image si elle existe
    if (document) formData.append("document", document); // Ajout du document si nécessaire

    formData.forEach((value, key) => {
      console.log(`${key} :`, value);
    });

    try {
      // Envoi de la requête pour modifier le projet
      const response = await baseApiUrl.put(`/publication/update/${editingProjet.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Mise à jour de la liste des projets
      const updatedProjet = await response.data;
      console.log("Projet mis à jour:", updatedProjet);

      setProjets(
        projets.map((projet) => (projet.id === updatedProjet.id ? updatedProjet : projet))
      );

      openNotificationWithIcon("success", "Publication modifié avec succès.");
      fetchPublications();
    } catch (error) {
      console.error("Erreur lors de la modification du projet:", error);
      openNotificationWithIcon("error", "Erreur lors de la modification du projet.");
    }

    // Réinitialisation du formulaire après l'envoi
    resetForm();
  };







  const handleEdit = (projet) => {
    setViewingProjet(projet);
    setEditingProjet(projet);

    setTitre(projet.titre);
    setDescription(projet.description);
    setZoneExecution(projet.zoneExecution);
    setImpactEconomique(projet.impactEconomique);
    setImpactSocial(projet.impactSocial);
    setImpactEnvironnemental(projet.impactEnvironnemental);
    setSelectedCategorie(projet.categorieId);
    setImage(projet.image);
    setDocument(projet.document);
    setCalendrierDebut(projet.calendrierDebut);
    setCalendrierFin(projet.calendrierFin);
    setIsEditMode(true);
    setIsEditModalVisible(true);


    setSelectedCategorie(projet.categorieId); // Assurez-vous de définir la catégorie sélectionnée correctement
    setIsEditModalVisible(true);
  };


  // const handleDelete = async (idProjet) => {
  //   try {
  //     const response = await baseApiUrl.delete(`/publication/delete/${idProjet}`);

  //     if (response.status !== 200) {
  //       throw new Error(`Erreur HTTP: ${response.status}`);
  //     }

  //     setPublications(publications.filter((projet) => projet.id !== idProjet));
  //     setDeleteModalVisible(false);
  //     setDeleteProjet(null);
  //     openNotificationWithIcon("success", "Publication supprimé avec succès.");
  //   } catch (error) {
  //     openNotificationWithIcon(
  //       "error",
  //       "Erreur lors de la suppression du projet."
  //     );
  //     console.error("Erreur:", error);
  //   }
  // };
  const handleDelete = async (idProjet) => {
    try {

      const response = await baseApiUrl.delete(`/publication/delete/${idProjet}`);

      if (response.status !== 200 && response.status !== 204) {
        console.error(`Statut inattendu : ${response.status}`); // Log du statut inattendu
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Mise à jour de la liste des publications
      setPublications((prevPublications) =>
        prevPublications.filter((projet) => projet.id !== idProjet)
      );


      setDeleteModalVisible(false);
      setDeleteProjet(null);

      // Afficher une notification de succès
      openNotificationWithIcon("success", "Publication supprimée avec succès.");
    } catch (error) {
      // Logs pour les erreurs
      console.error("Erreur lors de la suppression :", error.message || error);
      openNotificationWithIcon(
        "error",
        "Une erreur est survenue lors de la suppression de la publication."
      );
    }
  };


  const handleDeletes = async (idProjet) => {
    try {
      // Envoyer une requête DELETE pour supprimer la publication
      const response = await baseApiUrl.delete(`/publication/delete/${idProjet}`);

      // Vérifier explicitement si la réponse a réussi
      if (response.status === 200) {
        // Mettre à jour la liste des publications localement
        setPublications((prevPublications) =>
          prevPublications.filter((projet) => projet.id !== idProjet)
        );

        // Fermer la modale de suppression et réinitialiser les états
        setDeleteModalVisible(false);
        setDeleteProjet(null);

        // Afficher une notification de succès
        openNotificationWithIcon("success", "Publication supprimée avec succès.");
        (fetchPublications);
      } else {
        // Gérer les autres statuts HTTP comme des erreurs
        throw new Error(`Erreur HTTP : ${response.status}`);
      }
    } catch (error) {
      // Afficher une notification d'erreur et journaliser le problème
      openNotificationWithIcon(
        "error",
        "Une erreur est survenue lors de la suppression de la publication."
      );
      console.error("Erreur :", error);
    }
  };



  const handleStatusChange = async (key, value) => {
    // Vérifiez que key (ID du projet) est bien défini
    console.log("ID du projet:", key); // Assurez-vous que key n'est pas undefined

    if (key === undefined) {
      console.error("ID du projet est manquant !");
      return;
    }

    try {
      // Appel à l'API pour activer ou désactiver le projet
      const response = await baseApiUrl.put(
        `/publication/activeDesactive/${key}`,
        {
          actif: value, // Passez la valeur de l'état actif
        }
      );

      // Vous pouvez afficher la réponse de l'API si nécessaire
      console.log(response.data);
      fetchPublications(); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
    } catch (error) {
      console.error("Erreur lors de la mise à jour du projet:", error); // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
      // Rétablir l'état précédent en cas d'erreur
      const revertedData = data.map((item) => {
        if (item.id === key) {
          return { ...item, actif: !value };
        }
        return item;
      });
      setData(revertedData);
      // Vous pouvez afficher la réponse de l'API si nécessaire
      //   console.log(response.data); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
      // } catch (error) {
      //   console.error('Erreur lors de la mise à jour du projet:', error);
      // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
    }
  };

  const resetForm = () => {
    setStep(1);
    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
    setTitre("");


    setDescription("");

    setSelectedCategorie("");
    setImage("");
    setDocument("");

    setZoneExecution("");
    setImpactEconomique("");
    setImpactEnvironnemental("");
    setImpactSocial("")


    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
  };

  const handleView = (projet) => {
    setViewingProjet(projet);
    setIsViewModalVisible(true);
  };

  const handleNext = () => {
    setStep(step + 1);
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
      }
      return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
    } else {
      return ""; // Retourne une chaîne vide si text est undefined ou null
    }
  };

  const filteredProjets = publications.filter(
    (projet) =>
      projet.titre &&
      projet.titre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Publications</h3>
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>


              <div className="col-sm-5 col">
                <Button
                type="success"
                  onClick={() => {
                    resetForm();
                    setIsAddModalVisible(true);
                  }}
                  className="float-end mt-2 btn-success"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" /> {/* Icône ajoutée ici */}
                  Ajouter
                </Button>
              </div>
            </div>
          </div>
          <Table
            rowKey="id"
            columns={[
              {
                title: "Titre",
                dataIndex: "titre",
                key: "titre",
                render: (text) => truncateText(text, 6), // Tronque le titre à 5 mots
              },
              {
                title: "Description",
                dataIndex: "description",
                key: "description",
                render: (text) => truncateText(text, 6), // Tronque le titre à 5 mots
              },
              {
                title: "Zone d'exécution",
                dataIndex: "zoneExecution",
                key: "zoneExecution",
                render: (text) => truncateText(text, 6), // Tronque la description à 10 mots
              },

              {
                title: "Etat",
                dataIndex: "actif",
                key: "actif",
                render: (actif, record) => (
                  <Switch
                    checked={actif}
                    onChange={(checked) =>
                      handleStatusChange(record.id, checked)
                    }
                  />
                ),
              },

              {
                title: "Image",
                dataIndex: "image",
                key: "image",
                render: (imageName) => {
                  // Définir le chemin complet de l'image
                  const imageUrl =
                    baseApiUrl.defaults.baseURL + `/image/${imageName}`;
                  return (
                    <img
                      src={imageUrl}
                      alt="publication"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  );
                },
              },
              {

                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => {
                        resetForm();
                        handleView(record);
                      }}
                    >
                      Voir
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => {
                        resetForm();
                        handleEdit(record);
                      }}
                    >
                      Modifier
                    </Button>

                    <Button
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDeleteConfirm(record)}
                    >
                      Supprimer
                    </Button>
                  </div>
                ),
              },
            ]}
            dataSource={filteredProjets}
          />

          {/* Modal d'ajout de projet */}
          <Modal
            title="Ajouter une publication"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            width={800}
          >
            <form onSubmit={handleAddProjet}>
              {step === 1 && (
                <>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Titre de la publication</label>
                        <input
                          type="text"
                          className="form-control"
                          value={titre}
                          onChange={(e) => setTitre(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Zone d'exécution</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={zoneExecution}
                          onChange={(e) => setZoneExecution(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact économique</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactEconomique}
                          onChange={(e) => setImpactEconomique(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Description de la publication</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={description}
                          onChange={(e) =>
                            setDescription(e.target.value)
                          }
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact environnemental</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactEnvironnemental}
                          onChange={(e) => setImpactEnvironnemental(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact Social</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactSocial}
                          onChange={(e) => setImpactSocial(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleNext}
                  >
                    Suivant
                  </button>
                </>
              )}

              {step === 2 && (
                <>


                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Domaine de la publication</label>
                        <select
                          className="form-control"
                          value={selectedCategorie}
                          onChange={(e) => setSelectedCategorie(Number(e.target.value))}                        >
                          <option value="">Sélectionnez un domaine...</option>
                          {/* Valeur par défaut */}
                          {categoriesOptions.map((category) => (
                            <option key={category.value} value={category.value}>
                              {category.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Document du publication</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setDocument(e.target.files[0])}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Image de la publication</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setImage(e.target.files[0])}
                        />
                      </div>
                    </div>
                  </div>



                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handlePrevious}
                  >
                    Précédent
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary"

                  >
                    Créer
                  </button>
                </>
              )}
            </form>
          </Modal>

          {/* <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onOk={confirmDelete}
            onCancel={handleCancelDelete}
            okText="Supprimer"
            cancelText="Annuler"
          >
            <p>
              Êtes-vous sûr de vouloir supprimer ce projet ? Cette action est
              irréversible.
            </p>
          </Modal> */}

          <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onCancel={() => setDeleteModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setDeleteModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => handleDelete(deleteProjet.id)}
              >
                Supprimer
              </Button>,
            ]}
          >
            <p>
              Êtes-vous sûr de vouloir supprimer cette publication ? Cette action est
              irréversible.
            </p>
          </Modal>

          {/* Modal de modification de projet */}

          <Modal
            title="Modifier une publication"
            visible={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            width={800}
          >
            <form onSubmit={handleEditProjet}>
              {step === 1 && (
                <>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Titre de la publication</label>
                        <input
                          type="text"
                          className="form-control"
                          value={titre}
                          onChange={(e) => setTitre(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Zone d'exécution</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={zoneExecution}
                          onChange={(e) => setZoneExecution(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact économique</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactEconomique}
                          onChange={(e) => setImpactEconomique(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Description de la publication</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={description}
                          onChange={(e) =>
                            setDescription(e.target.value)
                          }
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact environnemental</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactEnvironnemental}
                          onChange={(e) => setImpactEnvironnemental(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact Social</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactSocial}
                          onChange={(e) => setImpactSocial(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleNext}
                  >
                    Suivant
                  </button>
                </>
              )}

              {step === 2 && (
                <>


                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Domaine de la publication</label>
                        <select
                          className="form-control"
                          value={selectedCategorie}
                          onChange={(e) => setSelectedCategorie(Number(e.target.value))}                        >
                          <option value="">Sélectionnez un domaine...</option>
                          {/* Valeur par défaut */}
                          {categoriesOptions.map((category) => (
                            <option key={category.value} value={category.value}>
                              {category.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Document du publication</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setDocument(e.target.files[0])}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Image de la publication</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setImage(e.target.files[0])}
                        />
                      </div>
                    </div>
                  </div>



                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handlePrevious}
                  >
                    Précédent
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary"

                  >
                    Créer
                  </button>
                </>
              )}
            </form>
          </Modal>

          {/* Modal pour afficher les détails  */}

          <Modal
            title="Information de la publication"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            width={800}
          >
            {viewingProjet && (
              <div >
                {step === 1 && (
                  <>

                    <div>
                      {/* <h4>{viewingProjet?.titre}</h4> */}
                      <p>
                        <strong>Titre de la publication:</strong> {viewingProjet?.titre}
                      </p>
                      <p>
                        <strong>Zone d'exécution:</strong> {viewingProjet?.zoneExecution}
                      </p>
                      <p>
                        <strong>Impact économique:</strong> {viewingProjet?.impactEconomique}
                      </p>
                      <p>
                        <strong>Description de la publication:</strong> {viewingProjet?.description}
                      </p>

                    </div>


                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleNext}
                    >
                      Suivant
                    </button>
                  </>
                )}

                {step === 2 && (
                  <>
                    <div>
                      <p>
                        <strong>Impact environnemental:</strong> {viewingProjet?.impactEnvironnemental}
                      </p>
                      <p>
                        <strong>Impact Social:</strong> {viewingProjet?.impactSocial}
                      </p>
                      <p>
                        <strong>Domaine de la publication:</strong> {viewingProjet?.selectedCategorie}
                      </p>

                      <p>
                        <strong>Date de creation:</strong> {viewingProjet?.created}
                      </p>

                    </div>

                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handlePrevious}
                    >
                      Précédent
                    </button>
                  </>
                )}
              </div>
            )}
          </Modal>

        </div>
      </div>
    </>
  );
};

export default Publication;
